import { EventNames } from '../../types/misc.types'
import { lightImpactVibrate, trackEvent } from '../../utils/appBridge'
import {
  ElitePlansAnalyticsScreen,
  type ElitePlansAnalyticsScreenType,
  ElitePlansEventId
} from './constants/analyticsEvents'

export {
  ElitePlansAnalyticsScreen,
  ElitePlansEventId,
  type ElitePlansAnalyticsScreenType
} from './constants/analyticsEvents'

type AnalyticsPayload = Record<string, string | number | boolean | undefined>

/** Set by `ElitePlansLandingProvider` so click helpers attribute to the active route screen. */
let activeElitePlansAnalyticsScreen: ElitePlansAnalyticsScreenType =
  ElitePlansAnalyticsScreen.Landing

/** Bind the mounted route’s analytics screen (called from the landing provider). */
export function setActiveElitePlansAnalyticsScreen(screen: ElitePlansAnalyticsScreenType) {
  activeElitePlansAnalyticsScreen = screen
}

function buildPayload(
  screen: ElitePlansAnalyticsScreenType,
  eventId: string,
  extra?: AnalyticsPayload
): AnalyticsPayload {
  return {
    screenType: screen,
    eventId,
    ...extra
  }
}

/**
 * ScreenLoaded for Elite Plans routes.
 * `screenType` is the route screen; `eventId` is `${screen}_${tier}_${from}`
 * (omitting empty segments) so tier/from are not separate payload fields.
 */
export function trackElitePlansScreenLoaded(
  screen: ElitePlansAnalyticsScreenType,
  props?: AnalyticsPayload
) {
  const { tier, from, ...rest } = props ?? {}
  const eventId = [screen, tier, from]
    .map((part) => (typeof part === 'string' ? part.trim() : part))
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join('_')

  trackEvent({
    eventName: EventNames.ScreenLoaded,
    payload: buildPayload(screen, eventId, rest)
  })
}

/** Thin bridge to app analytics + haptics; event ids live in `constants/analyticsEvents`. */
export function trackElitePlansClick(eventId: string, props?: AnalyticsPayload) {
  lightImpactVibrate()
  trackEvent({
    eventName: EventNames.UserClicked,
    payload: buildPayload(activeElitePlansAnalyticsScreen, eventId, props)
  })
}
